import axios from "axios";

import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { Document, DocumentType } from "../utils/types/document";

export const composerAssociatedDocumentsQueryKey = (jobId: string) =>
  ["composerAssociatedDocuments", jobId] as const;

export const fetchDocumentListData = async (
  jobId: string,
  // params: {
  //   page: number;
  //   pageSize: number;
  // }
) => {
  const resData = await axiosServices.get(`/jobs/${jobId}/documents`, {
    // params: {
    //   page: (params.page as number) + 1,
    //   start: (params.page as number) * (params.pageSize as number),
    //   // limit: params.pageSize,
    // },
  });
  const data = convertToCamelCase<Document[]>(resData.data.data);
  return {
    data,
    // total: resData.data.total,
  };
};

export const fetchDocumentTypeListData = async () => {
  const resData = await axiosServices.get("/documenttype");
  return convertToCamelCase<DocumentType[]>(resData.data.data);
};

export const addDocumentTypeData = async (data: Partial<DocumentType>) => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.post("/documenttype", inputData);
  return convertToCamelCase<DocumentType>(response.data.data);
};

export const updateDocumentTypeData = async (
  id: string,
  data: Partial<DocumentType>
) => {
  const inputData = convertToSnakeCase(data);
  await axiosServices.put(`/documenttype/${id}`, inputData);
  return { success: true, data };
};

export const deleteDocumentTypeData = async (id: string) => {
  const response = await axiosServices.delete(`/documenttype/${id}`);
  return { success: response.data.success, id };
};

export const updateDocumentData = async (
  id: string,
  data: {
    [key: string]: any;
    documentId: string;
  }
) => {
  const inputData = convertToSnakeCase(data);
  await axiosServices.put(`/documents/${id}`, inputData);
  return {
    success: true,
    data,
  };
};

export const deleteDocumentData = async (id: string, jobId: string) => {
  const response = await axiosServices.delete(`jobs/${jobId}/documents/${id}`);
  return { success: response.data.success, id };
};

export const fetchDocumentDetails = async (id: string) => {
  const resData = await axiosServices.get(`/documents/${id}`);
  return convertToCamelCase<{
    documentId: string;
    fileName?: string | null;
    fileUrl: string | null;
    mimeType?: string | null;
    size?: number | null;
  }>(resData.data.data);
};

export const fileUpload = async (file: Blob, type: string, name: string, jobId?:string) => {
  const response = await axiosServices.get("/signed_url", {
    params: {
      ContentType: type,
      key: name,
      operation: "put",
      jobId, // Optional job ID for context
    },
  });

  if (response.status !== 200) {
    throw new Error(`Failed to get signed URL: ${response.statusText}`);
  }

  const signedUrl = response.data.data.pre_signed_url;

  const uploadResponse = await axios.put(signedUrl, file, {
    headers: {
      "Content-Type": type,
    },
  });

  if (uploadResponse.status !== 200) {
    throw new Error(`Failed to upload file: ${uploadResponse.statusText}`);
  }
  return {
    success: true,
    key: response.data.data.final_key, // Return the base URL without query parameters
  };
};

export const addDocumentData = async (
  data: {
    [key: string]: any;
  },
  jobId: string
) => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.post(
    `/jobs/${jobId}/documents`,
    inputData
  );
  return convertToCamelCase<Document>(response.data.data);
};
